import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { currentUserQueryOptions } from '@/features/auth/queries'
import { useAuthStore } from '@/stores/auth-store'
import { SignIn } from '@/features/auth/sign-in'
import { isAuthenticationError } from '@/lib/auth-errors'

const searchSchema = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute('/(auth)/sign-in')({
  beforeLoad: async ({ context }) => {
    const auth = useAuthStore.getState().auth
    if (!auth.accessToken) return

    try {
      await context.queryClient.ensureQueryData(currentUserQueryOptions())
    } catch (error) {
      if (isAuthenticationError(error)) {
        auth.reset()
      }
      return
    }

    throw redirect({ to: '/', replace: true })
  },
  component: SignIn,
  validateSearch: searchSchema,
})
